import styled, { css } from "styled-components";

import {
  ERROR_LIGHT,
  ERROR_LIGHTEST,
  GRAY,
  GRAY_LIGHT,
  GRAY_LIGHTEST,
  TEXT_PRIMARY,
  WHITE
} from "../../../../colors";
import { LARGE_SCREEN } from "../../../../constants/screenSizes";
import { chevron } from "../../../assets";
import { withInputSizeStyles } from "../../../styled";

const withBackgroundStyles = ({ isValid }) => {
  const backgroundColor = isValid ? WHITE : ERROR_LIGHTEST;

  return css`
    background-color: ${backgroundColor};
    background-image: url(${chevron});
    background-position: calc(100% - 12px) center;
    background-repeat: no-repeat;
  `;
};

const withBorderStyles = ({ isValid }) => {
  const borderColor = isValid ? GRAY : ERROR_LIGHT;

  return css`
    border: 1px solid ${borderColor};
  `;
};

export const Select = styled.select.attrs({
  multiple: false
})`
  * {
    box-sizing: border-box;
  }

  -webkit-appearance: none;
  -webkit-border-radius: 0;
  -webkit-font-smoothing: antialiased;
  color: ${TEXT_PRIMARY};
  font-family: "Source Sans Pro", Helvetica, Arial, Geneva, sans-serif;
  font-size: 14px;
  padding: 0 32px 0 16px;
  width: 100%;

  &:disabled {
    background: ${GRAY_LIGHT};

    &:not([value=""]) {
      background: ${GRAY_LIGHTEST};
    }
  }

  @media screen and (max-width: ${LARGE_SCREEN}px) {
    font-size: 16px;
    line-height: 24px;
  }

  ${withBackgroundStyles};
  ${withBorderStyles};
  ${withInputSizeStyles};
`;
